<div class="alert overflow-hidden p-0 alert-{{type}} alert-dismissible fade show" role="alert">
  <div class="progress cp-alert__progress" style="direction: rtl;">
    <div class="progress-bar bg-{{type}}" role="progressbar" [style.width]="progress + '%'" style="transition: width linear 0.1s;"></div>
  </div>
  <div class="cp-alert__text">{{text}}</div>
  <button (click)="notificationRef.close()" type="button" class="btn-close cp-alert__close" aria-label="Close"></button>
</div>

